<!-- Modal Wrapper - Prevents backdrop clicks from closing modal -->
<div class="appr-config-modal-wrapper" (click)="$event.stopPropagation()">
<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body no-modal-body-scroll" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div class="panel panel-default">
    <div class="panel-body">
      <div class="row">
        <!-- Appr Type Dropdown -->
        <div class="col-md-3">
          <div class="form-group">
            <label for="gie_name"><b>Appr Type:</b></label>
            <select id="gie_name" 
                    class="form-control" 
                    [(ngModel)]="grossIncome"
                    (ngModelChange)="onGrossIncomeChange()"
                    [disabled]="!isCreate">
              @for (option of grossIncomeDetails; track $index) {
<option 
                      [ngValue]="option">
                {{option.GIE_SHORT_DESC}}
              </option>
}
            </select>
          </div>
        </div>

        <!-- Filer Entity - Multiselect for Add mode, Single select for Edit mode -->
        <div class="col-md-4">
          <div class="form-group">
            <label for="filerentity"><b>Filer Entity:</b></label>
            
            <!-- Add Mode: Searchable Multiselect -->
            @if (isCreate) {
<div class="searchable-multiselect-container">
              <div class="custom-searchable-multiselect" 
                   [class.open]="filerEntityDropdownOpen"
                   dstClickOutside
                   (clickOutside)="closeFilerEntityDropdown()">
                <div class="dropdown-input-wrapper" 
                     (click)="toggleFilerEntityDropdown()">
                  <input type="text" 
                         class="form-control dropdown-input" 
                         [value]="getSelectedFilerEntitiesDisplay()"
                         readonly
                         placeholder="Select Filer Entities">
                  <i class="fa fa-chevron-down dropdown-arrow" 
                     [ngClass]="{'fa-chevron-up': filerEntityDropdownOpen, 'fa-chevron-down': !filerEntityDropdownOpen}"></i>
                </div>
                @if (filerEntityDropdownOpen) {
<div class="dropdown-menu" 
                    
                     (click)="$event.stopPropagation()">
                  <div class="dropdown-search-wrapper">
                    <input type="text" 
                           class="form-control dropdown-search-input" 
                           [(ngModel)]="filerEntitySearchText"
                           (ngModelChange)="onFilerEntitySearchChange()"
                           placeholder="Search filer entities..."
                           (click)="$event.stopPropagation()">
                    <i class="fa fa-search dropdown-search-icon"></i>
                  </div>
                  <div class="dropdown-actions">
                    <button type="button" 
                            class="btn btn-link btn-sm select-all-btn"
                            (click)="selectAllFilerEntities(); $event.stopPropagation()">
                      Select All
                    </button>
                    <button type="button" 
                            class="btn btn-link btn-sm unselect-all-btn"
                            (click)="unselectAllFilerEntities(); $event.stopPropagation()">
                      Unselect All
                    </button>
                  </div>
                  <div class="dropdown-items-wrapper">
                    @if (filerEntityFilteredData.length === 0) {
<div 
                         class="dropdown-no-results">
                      No results found
                    </div>
}
                    @for (option of filerEntityFilteredData; track $index) {
<div 
                         class="dropdown-item checkbox-item"
                         [class.disabled]="option.FILER_LE_KEY === ''"
                         (click)="!isCheckboxClick($event) && toggleFilerEntitySelection(option); $event.stopPropagation()">
                      <input type="checkbox" 
                             [checked]="isFilerEntitySelected(option.FILER_LE_KEY)"
                             [disabled]="option.FILER_LE_KEY === ''"
                             (change)="toggleFilerEntitySelection(option); $event.stopPropagation()"
                             (click)="$event.stopPropagation()">
                      <label [class.disabled]="option.FILER_LE_KEY === ''"
                             (click)="toggleFilerEntitySelection(option); $event.stopPropagation()">
                        {{ option.FILER_LE }}
                      </label>
                    </div>
}
                  </div>
                </div>
}
              </div>
            </div>
}

            <!-- Edit Mode: Single Select (Disabled) -->
            @if (!isCreate) {
<select
                    id="filerentity" 
                    class="form-control" 
                    [(ngModel)]="filerEntityEdit"
                    disabled>
              @for (option of filingEnityDetails; track $index) {
<option 
                      [ngValue]="option">
                {{option.FILER_LE}}
              </option>
}
            </select>
}
          </div>
        </div>

        <!-- Status Dropdown -->
        <div class="col-md-2">
          <div class="form-group">
            <label for="status"><b>Status:</b></label>
            <select id="status" 
                    class="form-control"
                    [(ngModel)]="status">
              @for (option of statusDetails; track $index) {
<option 
                      [ngValue]="option">
                {{option.LOCK_DESC}}
              </option>
}
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          (click)="save()" 
          [disabled]="isSaveClicked || crudLoading"> 
    @if (isSaveClicked || crudLoading) {
<span>
      <i class="fa fa-spinner fa-pulse"></i>
    </span>
}
    Save
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">
    Reset
  </button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">
    Cancel
  </button>
</div>
</div>
<!-- End Modal Wrapper -->
